const Config = require("../config");

const Calc   = require("../utillity/calculate");
const Rwd    = require("../utillity/responsive");
const Utill  = require("../utillity/utill");

const $S     = $('[data-home_deco]');

/*
	MVの装飾を設定
*/
module.exports.InitMvDeco = function() {
	//let wh = $(window).height();
	//let dw = Calc.GetWidthByHeight(wh);
	//let v  = 'skew(-30deg) translate(' + dw + 'px, ' + -wh + 'px)';
	//console.log(v);
	//$('[data-home_deco]').css({'transform': v,});
};

/*
	MVデコレーション。
	slickのbefore functionで発火
*/
module.exports.BeforeChangeDeco = function() {
	let tl = new TimelineMax();

	tl
		.to($S, Calc.ToSecond(180), {
			opacity: 0,			
			ease: Expo.easeOut,
		}).set($S, {
			width: 0,
		});
};

/*
	MVデコレーション。
	slickのafter functionで発火
*/
module.exports.AfterChangeDeco = function() {
	let tl = new TimelineMax();

	tl
		.set($S, {
			width: 0,
			opacity: 1,
		}).to($S, Calc.ToSecond(900), {
			ease: Circ.easeOut,
			width: '100%',
		});
};

/*
	セクション変更時のアニメーションを設定する。
*/
module.exports.SectionControllerInit = function() {
	if( Utill.IsOriginAnime() || Utill.IsPage('home') ) {
		let base_val = $(window).innerHeight();
		let d = Calc.GetWidthByHeight( base_val / 2 );
		let w = $(window).innerWidth() / 2 + d;
		let tl = new TimelineMax();
		let target = $('.section-pager__left, .section-pager__right');

		tl.set(target, {
			width: w,
			backgroundColor: '#00afdb',
		}).set(target[0], {
			y: base_val,
			x: -1 * Calc.GetWidthByHeight( base_val )
		}).set(target[1], {
			y: -1 * base_val,
			x: Calc.GetWidthByHeight( base_val )
		});

	}else {
		return;
	}
};
module.exports.SectionController = function(d) {};
module.exports.beforeSectionChanger = function(d) {
	let tl = new TimelineMax();
	let target = $('.section-pager__left, .section-pager__right');

	tl
		.set($('.section-pager'), {visibility: 'visible'})
		.to(target, Calc.ToSecond(450), {
			y: 0,
			x: 0,
			ease: Expo.easeOut
		});
};
module.exports.AfterSectionChanger = function(dire) {
	let base_val = $(window).innerHeight();
	let m = $(window).innerWidth() / 2 + Calc.GetWidthByHeight( base_val );	// 
	let d = Calc.GetWidthByHeight( base_val / 2 );
	let w = $(window).innerWidth() / 2 + d;
	let tl = new TimelineMax();
	let target = $('.section-pager__left, .section-pager__right');

		tl.to(target[0],
			Calc.ToSecond( 360 ), {
			//x: -m,
			width: 0,
			ease: Expo.easeOut,
		}, '0').to(target[1],
			Calc.ToSecond( 360 ), {
			//x: m,
			width: 0,
			ease: Expo.easeOut,
		}, '0')
		.set(target[0], {
			y: base_val,
			width: w,
			x: -1 * Calc.GetWidthByHeight( base_val ),
		}).set(target[1], {
			y: -1 * base_val,
			width: w,
			x: Calc.GetWidthByHeight( base_val ),
		}).set($('.section-pager'), {visibility: 'hidden'});
};


// WEBPACK FOOTER //
// ./html/_src/js_wb/animation/home.js